import { UseQueryOptions } from '@tanstack/react-query';

import useQuery from 'hooks/useQuery';
import { CuredApiPaths } from 'models/enums';

import QueryKeys from './keys';

export type CopyGeneratorHistoryMessageFeedback = {
    rating: 'like' | 'dislike';
    tags: string[] | null;
    reviewText: string | null;
};

export type CopyGeneratorHistoryMessage = {
    id: number;
    role: 'user' | 'assistant';
    content: string;
    feedback: CopyGeneratorHistoryMessageFeedback | null;
};

export type CopyGeneratorHistoryResponse = {
    sessionId: number;
    messages: CopyGeneratorHistoryMessage[];
} | null;

/**
 * Fetches the most recent chat session and its message history for a given template.
 * Returns null when no prior session exists for this template.
 * Should only be called when templateId is a valid positive integer (not new-content mode).
 */
const useCopyGeneratorHistory = (
    templateId: number,
    reactQueryOptions?: UseQueryOptions<CopyGeneratorHistoryResponse, Error>
) =>
    useQuery<CopyGeneratorHistoryResponse>(
        QueryKeys.COPY_GENERATOR_HISTORY(templateId),
        `${CuredApiPaths.COPY_GENERATOR_HISTORY}?templateId=${templateId}`,
        reactQueryOptions
    );

export default useCopyGeneratorHistory;
